export default "/_next/static/images/2-8fc6671a604f35cc17daf4ebf9e489c3.png";